<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#00ACC1">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      width="625"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id.length > 0 ? 'Ubah Data' : 'Tambah' }} Pengguna
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="reset()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="pt-2" style="height: 750px;">
          <ValidationObserver ref="form">
            <v-form>
              <div class="mb-6">
                <p class="mb-2">
                  Gambar Profil (bisa dikosongi)
                </p>

                <uploadimage v-model="images">
                  <div slot="activator">
                    <v-card
                      outlined
                      class="d-flex align-center justify-center cursor-pointer"
                      width="175"
                      height="175">
                      <v-avatar v-if="!process.image"
                        v-ripple
                        tile 
                        width="173"
                        height="173" 
                        class="cursor-pointer">
                        <v-img 
                          v-if="form.image_url.length > 0"
                          contain
                          width="173"
                          height="173"
                          alt="VENOM"
                          :src="form.image_url">
                        </v-img>

                        <v-icon v-else large>mdi-camera-plus</v-icon>
                      </v-avatar>

                      <v-progress-circular v-else
                        indeterminate
                        color="#00ACC1">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadimage>
              </div>

              <ValidationProvider name="code" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Kode Pengguna
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 35%;'"
                  dense
                  outlined
                  placeholder="Ex. AMJ001"
                  color="#00ACC1"
                  v-model="form.code"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Nama Lengkap
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 70%;'"
                  dense
                  outlined
                  placeholder="Ex. John Doe"
                  color="#00ACC1"
                  v-model="form.name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="username" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Username
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 45%;'"
                  dense
                  outlined
                  placeholder="Ex. johndoe"
                  color="#00ACC1"
                  v-model="form.username"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Email
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 45%;'"
                  dense
                  outlined
                  placeholder="Ex. johndoe@gmail.com"
                  color="#00ACC1"
                  v-model="form.email"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider name="mobilephone" rules="required|min:10|max:14" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Telepon
                </p>

                <v-text-field
                  v-on:keyup.enter="save()"
                  :style="rps === 'xs' ? '' : 'width: 50%;'"
                  type="number"
                  dense
                  outlined
                  placeholder="Ex. 081XXXXXXXXX"
                  color="#00ACC1"
                  v-model="form.mobilephone"
                  :counter="14" 
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>

              <v-row>
                <v-col cols="12" md="6" sm="6" class="py-0">
                  <ValidationProvider name="role" rules="required" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Role
                    </p>

                    <v-select
                      v-on:keyup.enter="save()"
                      :items="[
                        {
                          text: 'Admin',
                          value: 'admin'
                        },
                        {
                          text: 'Staff',
                          value: 'staff'
                        }
                      ]"
                      placeholder="Pilih Role"
                      outlined
                      dense
                      color="#00ACC1"
                      item-text="text"
                      item-value="value"
                      item-color="cyan darken-1"
                      v-model="form.role"
                      :error-messages="errors"
                      require>
                    </v-select>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" md="6" sm="6" class="py-0">
                  <ValidationProvider name="position" rules="required" v-slot="{ errors }">
                    <p class="mb-2">
                      <span class="red--text">*</span>
                      Posisi
                    </p>

                    <v-select
                      v-on:keyup.enter="save()"
                      :items="[
                        {
                          text: 'Kolektor',
                          value: 'kolektor'
                        },
                        {
                          text: 'Marketing',
                          value: 'marketing'
                        }
                      ]"
                      placeholder="Pilih Posisi"
                      outlined
                      dense
                      color="#00ACC1"
                      item-text="text"
                      item-value="value"
                      item-color="cyan darken-1"
                      v-model="form.position"
                      :error-messages="errors"
                      require>
                    </v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider name="office" rules="required" v-slot="{ errors }">
                <p class="mb-2">
                  <span class="red--text">*</span>
                  Lokasi Kantor
                </p>

                <v-select
                  :style="rps === 'xs' ? '' : 'width: 50%;'"
                  :loading="process.office"
                  :items="office"
                  placeholder="Pilih Kantor"
                  outlined
                  dense
                  color="#00ACC1"
                  item-text="name"
                  item-value="id"
                  item-color="cyan darken-1"
                  v-model="form.office_id"
                  :error-messages="errors"
                  require>
                </v-select>
              </ValidationProvider>

              <div>
                <p class="mb-2">
                  Alamat (bisa dikosongi)
                </p>

                <v-textarea
                  v-on:keyup.enter="save()"
                  outlined
                  dense
                  placeholder="Ex. Jl. Ahmad Yani No. 77"
                  hide-details
                  rows="3"
                  color="#00ACC1"
                  v-model="form.address">
                </v-textarea>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="reset()">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Hapus Data Pengguna
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="body-1 font-weight-light text-first mt-4">
          Apakah anda yakin menghapus data pengguna yang anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.delete = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.activation"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Aktivasi Data Pengguna
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.activation = false; selected.activation = [];">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <p class="body-1 font-weight-light text-first">
            Anda dapat mengubah status aktivasi data pengguna, dengan memilih tombol di bawah :
          </p>

          <v-switch 
            v-model="active_bool"
            color="#00ACC1"
            hide-details>
            <template v-slot:label>
              <span class="body-1 font-weight-bold"
                :class="active_bool ? 'cyan--text text-darken-1' : 'text-second'">
                {{ active_bool ? 'Aktif' : 'Tidak Aktif' }}
              </span>
            </template>
          </v-switch>
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="Activation()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Ubah Status
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.activation = false; selected.activation = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.password"
      width="500"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Reset Password Pengguna
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.password = false; detail = {};">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="body-1 font-weight-light text-first mt-4">
          Apakah anda yakin mereset password data pengguna yang anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            @click="resetPassword()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Reset
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.password = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="dialog.detail"
      width="550"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Detail Pengguna
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.detail = false; detail = {};">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="pt-2">
          <v-row>
            <v-col cols="12" md="7">
              <div>
                <p class="text-second mb-0">
                  Kode Pengguna
                </p>

                <p class="body-1">
                  {{ detail.code }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Nama Lengkap
                </p>

                <p class="body-1">
                  {{ detail.name }}
                </p>
              </div>
              
              <div>
                <p class="text-second mb-0">
                  Email
                </p>

                <p class="body-1">
                  {{ detail.email }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Telepon
                </p>

                <p class="body-1">
                  {{ detail.mobilephone }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Role
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.role }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Posisi
                </p>

                <p class="body-1 text-capitalize">
                  {{ detail.position }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Status
                </p>

                <p class="body-1 text-capitalize font-weight-bold"
                  :class="detail.active_bool ? 'cyan--text text-darken-1' : ''">
                  {{ detail.active_bool ? 'Aktif' : 'Tidak Aktif' }}
                </p>
              </div>

              <div>
                <p class="text-second mb-0">
                  Alamat
                </p>

                <p class="body-1 text-capitalize mb-0">
                  {{ detail.address === '' ? '-' : detail.address }}
                </p>
              </div>
            </v-col>

            <v-col cols="12" md="5">
              <v-img 
                class="border-radius"
                contain
                alt="VENOM"
                width="175"
                height="175"
                :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member-default.jpg')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#00ACC1">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.detail = false; detail = {};">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    
    <v-row>
      <v-col cols="12">
        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="9" class="d-flex align-center">
                <div>
                  <v-btn
                    elevation="0"
                    style="background: #00acc133;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                    @click="reset()">
                    <v-icon size="18">mdi-plus-circle-outline</v-icon>

                    <span class="ml-1">
                      Tambah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #2196f333;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                    @click="reset(selected.row[0])">
                    <v-icon size="18">mdi-circle-edit-outline</v-icon>

                    <span class="ml-1">
                      Ubah
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length > 0">
                  <v-btn
                    elevation="0"
                    style="background: #f4403433;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                    @click="toDelete()">
                    <v-icon size="18">mdi-delete-circle-outline</v-icon>

                    <span class="ml-1">
                      Hapus
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length > 0">
                  <v-btn
                    elevation="0"
                    style="background: #ff980033;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center orange--text"
                    @click="toActivation()">
                    <v-icon size="18">mdi-check-circle-outline</v-icon>

                    <span class="ml-1">
                      Aktivasi
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <v-btn
                    elevation="0"
                    style="background: #8800ff33;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center purple--text"
                    @click="dialog.password = true; detail = selected.row[0]">
                    <v-icon size="18">mdi-shield-key-outline</v-icon>

                    <span class="ml-1">
                      Reset Password
                    </span>
                  </v-btn>
                </div>

                <div class="ml-3" v-if="selected.row.length === 1">
                  <!-- <v-btn
                    elevation="0"
                    style="background: #e0e0e0;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second"
                    @click="dialog.detail = true; detail = selected.row[0]">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                      Detail
                    </span>
                  </v-btn> -->

                  <v-btn
                    elevation="0"
                    style="background: #e0e0e0;"
                    class="body-2 text-capitalize font-weight-bold d-flex align-center text-second"
                    :to="`/user/${selected.row[0].id}`"
                    target="_blank">
                    <v-icon size="18">mdi-information-outline</v-icon>

                    <span class="ml-1">
                      Detail
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.name"
                  @click:clear="search.name = ''; fetch();"
                  v-on:keyup.enter="fetch()">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid-user text-capitalize"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '300px' : '228px'})`"
            fixed-header
            show-select
            :loading="process.load"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="headers"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick" 
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.email`]="{ item }">
              <span class="text-lowercase">
                {{ item.email }}
              </span>
            </template>

            <template v-slot:[`item.active_bool`]="{ item }">
              <span class="font-weight-bold"
                :class="item.active_bool ? 'cyan--text text-darken-1' : 'text-second'">
                {{ item.active_bool ? 'Aktif' : 'Tidak Aktif' }}
              </span>
            </template>

            <template v-slot:[`item.role`]="{ item }">
              {{ item.role }} ({{ item.position }})
            </template>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetch($event)" 
            @reloadPage="fetch($event)"
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          delete: false,
          activation: false,
          password: false,
          // detail: false,
          snackbar: false
        },
        search: {
          name: ''
        },
        selected: {
          row: [],
          delete: [],
          activation: []
        },
        options: {},
        detail: {},
        office: [],
        headers: [],
        list: [],
        pagination: {},
        limit: 20,
        images: '',
        active_bool: false,
        form: {
          id: '',
          code: '',
          name: '',
          username: '',
          email: '',
          mobilephone: '',
          role: '',
          position: '',
          address: '',
          image_url: '',
          office_id: ''
        },
        process: {
          load: false,
          image: false,
          form: false,
          office: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/uploadimage.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      'images': {
        handler: function () {
          if (this.images) {
            this.process.image = this.images.process 
            
            if (!this.process.image) this.form.image_url = this.images.fileuri
          }
        },
        deep: true
      },
      options: {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      async fetch(pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.name
        }

        await get(`admin/user`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.headers = [
              {
                text: 'Kode Pengguna',
                width: '150px',
                value: 'code'
              },
              {
                text: 'Nama Lengkap',
                width: '200px',
                value: 'name'
              },
              {
                text: 'Username',
                width: '150px',
                value: 'username'
              },
              {
                text: 'Email',
                width: '150px',
                value: 'email'
              },
              {
                text: 'Telepon',
                width: '150px',
                value: 'mobilephone'
              },
              {
                text: 'Role (Posisi)',
                width: '200px',
                value: 'role'
              },
              {
                text: 'Lokasi Kantor',
                width: '200px',
                value: 'office_name'
              },
              {
                text: 'Alamat',
                width: '500px',
                value: 'address'
              },
              {
                text: 'Status',
                width: '100px',
                value: 'active_bool'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      async fetchOffice() {
        this.process.office = true

        let params = {
          limit: 1000000
        }

        await get(`general/office`, { params }).then(response => {
          let res = response.data

          this.process.office = false
          
          if (res.status === 200) {
            this.office = res.results.data
          }
        })
      },
      reset(item) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          id: item === undefined ? '' : item.id,
          code: item === undefined ? '' : item.code,
          name: item === undefined ? '' : item.name,
          username: item === undefined ? '' : item.username,
          email: item === undefined ? '' : item.email,
          mobilephone: item === undefined ? '' : item.mobilephone,
          role: item === undefined ? '' : item.role,
          position: item === undefined ? '' : item.position,
          address: item === undefined ? '' : item.address,
          image_url: item === undefined ? '' : item.image_url,
          office_id: item === undefined ? '' : item.office_id
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchOffice()
      },
      async save() {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let url = this.form.id.length < 1 ? `admin/user/add` : `admin/user/update`
          
          this.process.form = true
          
          await post(url, {
            data: this.form
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
        }
      },
      toDelete() {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes() {
        this.message.error = ''

        this.process.form = true

        await post(`admin/user/deletes`, {
          data: {
            id_array: this.selected.delete
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },
      toActivation () {
        this.selected.activation = []

        if (this.selected.row.length > 1) {
          for (let i in this.selected.row) {
            this.selected.activation.push(parseInt(this.selected.row[i].id))
          }

          this.active_bool = false
        } else {
          this.selected.activation.push(parseInt(this.selected.row[0].id))
          this.active_bool = this.selected.row[0].active_bool
        }

        this.dialog.activation = true
      },
      async Activation () {
        this.message.error = ''

        this.process.form = true

        await post(`admin/user/activations`, {
          data: {
            id_array: this.selected.activation,
            active_bool: this.active_bool
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.activation = false

            for (let i in this.selected.row) {
              this.selected.row[i].active_bool = this.active_bool
            }
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      },
      async resetPassword() {
        this.message.error = ''

        this.process.form = true

        await post(`admin/user/reset_password`, {
          data: {
            id: this.detail.id
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.password = false

            this.detail = {}

            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetch()
          } else {
            this.process.form = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid-user table > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-user table > thead > tr > th:nth-child(3) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 64px; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-user table > tbody > tr > td:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 1;
    background: white;
  }
  .table-grid-user table > tbody > tr > td:nth-child(3) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 64px; 
    z-index: 1;
    background: white;
  }
</style>